<template>
  <div class="new-read-aloud">
    <organization-breadcrumb :items="[$t('study_sets.curriculum'), $t('read_aloud.create_read_aloud')]" />
    <div id="read-aloud-set-page">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :md="14" :lg="18" :xl="22">
          <h1 class="blue-color" style="text-align: center"
            v-if="createStudySetSteps.active == 1 || createStudySetSteps.active == 2">
            {{ $t("read_aloud.create_read_aloud_title") }}
          </h1>
          <h1 class="blue-color" style="text-align: center" v-else-if="createStudySetSteps.active == 3">
            {{ $t("read_aloud.review_confirm") }}
          </h1>
          <h1 class="blue-color" style="text-align: center" v-else>{{ $t("read_aloud.your_read_aloud") }}</h1>
          <div>
            <div class="read-aloud-create-main">
              <read-aloud-create-details ref="studysetdetail"
                v-if="createStudySetSteps.active === 1 || createStudySetSteps.active === 2" @generate="handleGenerate"
                :currentStep="createStudySetSteps.active" :componentStep="[1, 2]" v-on:next-step="handleNextStep"
                v-on:previous-step="handlePreviousStep" v-on:assign-to-class="handleAssignStudySetToClass" :isAdmin="true"
                :editMode="editMode" :organizationType="currentOrganizationType" />
              <!-- <read-aloud-image-uploader /> -->
              <read-aloud-overview v-if="createStudySetSteps.active == 3" :currentStep="createStudySetSteps.active"
                :componentStep="2" v-on:next-step="handleConfirmDoneCreateStudySet" v-on:last-step="lastStep"
                v-on:edit-step="handleEdit" v-on:cancel="handleCancel" v-on:assign-to-class="handleAssignStudySetToClass"
                :studysetDetails="buildingStudySet" :organizationType="currentOrganizationType" :uploadId.sync="uploadId"
                :organizationId="currentOrganizationId" />
            </div>
            <read-aloud-create-footer :primaryPreviousText="$t('common.cancel')" :cancelActive="true"
              v-if="createStudySetSteps.active == 2" :primaryPreviousActive="false" :primaryAction="clickContinue"
              :primaryCancelAction="handleCancel"
              :primaryText="createStudySetSteps.active === 1 ? 'Auto-Generate study sets' : 'Next'"
              :previousText="$t('common.cancel')" />
          </div>
        </el-col>
      </el-row>
    </div>
    <create-study-set-success-modal :dialogVisible="modals.showCreateStudySetSuccessModal"
      v-on:closed="handleConfirmDoneCreateStudySet" v-on:new-set="handleCreateNewStudySet"
      v-on:assign-class="handleAssignStudySetToClass" :studySetName="membershipSelectedDisplayName"
      :countOfPhrases="countOfPhrases" />
    <leave-create-study-set-modal :dialogVisible="modals.showLeaveCreateStudySetModal"
      v-on:closed="modals.showLeaveCreateStudySetModal = false" v-on:leave="handleConfirmCancel" />
    <add-assignment-wrapper ref="addAssignment" v-on:reload="handleExit" />
  </div>
</template>

<script>
// import Steps from '@/components/common/Steps'
import ReadAloudCreateDetails from "./create-read-aloud/ReadAloudCreateDetail";
import ReadAloudOverview from "./create-read-aloud/ReadAloudOverview";
import ReadAloudCreateFooter from "./create-read-aloud/ReadAloudCreateFooter";
import { mapActions, mapGetters, mapState } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import CreateStudySetSuccessModal from "@/components/modals/studysets/CreateStudySetSuccessModal";
import LeaveCreateStudySetModal from "@/components/modals/studysets/LeaveCreateStudySetModal";
import AddAssignmentWrapper from "@/components/modals/read-aloud/AddAssignmentWrapper";

export default {
  components: {
    // Steps,
    ReadAloudCreateDetails,
    ReadAloudOverview,
    ReadAloudCreateFooter,
    OrganizationBreadcrumb,
    CreateStudySetSuccessModal,
    LeaveCreateStudySetModal,
    AddAssignmentWrapper,
  },
  computed: {
    ...mapState("readAlouds", ["newReadAloud", "autoWarmUpStudySets"]),
    ...mapGetters({
      buildingStudySet: "readAlouds/getBuildingStudySet",
      currentOrganizationType: "organization/currentOrganizationType",
      currentOrganizationId: "organization/currentOrganizationId",
      getCurrentStudySet: "readAlouds/getCurrentStudySet",
    }),
    membershipSelectedDisplayName() {
      if (this.buildingStudySet && this.buildingStudySet.name) {
        return this.buildingStudySet.name;
      }
      return "";
    },
    countOfPhrases() {
      if (this.buildingStudySet && this.buildingStudySet.phrases) {
        return this.buildingStudySet.phrases.length;
      }
      return 0;
    },
    studySetDetails() {
      return this.buildingStudySet;
    },
  },
  data() {
    return {
      modals: {
        showInviteTeacherModal: false,
        showCreateStudySetSuccessModal: false,
        showLeaveCreateStudySetModal: false,
      },
      uploadId: null,
      inviteMode: null,
      editMode: false,
      createStudySetSteps: {
        active: 1,
        steps: [
          {
            title: this.$t("studysets.create_studyset_flow.details"),
          },
          {
            title: this.$t("studysets.create_studyset_flow.details"),
          },
          {
            title: this.$t("study_sets.review_confirm"),
          },
        ],
      },
      loading: null,
    };
  },
  methods: {
    ...mapActions("readAlouds", ["getWarmUpStudySets"]),
    clickContinue() {
      switch (this.createStudySetSteps.active) {
        case 1:
          this.modals.showModalSpellCheck = true;
          this.$refs.studysetdetail.handleContinueClick();
          break;
        case 2:
          this.modals.showModalSpellCheck = true;
          this.$refs.studysetdetail.handleContinueClick();
          break;
        default:
          return;
      }
    },
    async handleGenerate() {
      this.createStudySetSteps.active = 2;

      const payload = {
        max_items: 50,
        text: this.newReadAloud.text,
      };

      try {
        this.loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await this.getWarmUpStudySets(payload);
      } finally {
        this.loading && this.loading.close();
      }
    },
    handleNextStep(activeStep) {
      this.createStudySetSteps.active = activeStep + 1;

      if (this.createStudySetSteps.active > 3) {
        this.modals.showCreateStudySetSuccessModal = true;
      }
    },
    lastStep() {
      this.createStudySetSteps.active = 3;
    },
    handlePreviousStep(options = {}) {
      const activeStep = this.createStudySetSteps.active;
      this.createStudySetSteps.active = activeStep - 1;
    },
    handleEdit() {
      this.createStudySetSteps.active = 2;
      this.editMode = true;
    },
    handleAssignStudySetToClass() {
      this.modals.showCreateStudySetSuccessModal = false;
      this.$refs.addAssignment.handleAssignToClassReadAloud(this.getCurrentStudySet);
    },
    handleExit() {
      this.handleReset();

      return this.$router.push({
        name: "read-aloud",
        params: {
          organizationId: this.currentOrganizationId,
        },
      });
    },
    handleConfirmDoneCreateStudySet() {
      this.handleReset();
      this.$store.dispatch("readAlouds/setFinalWarmUpStudySets", []);

      this.modals.showCreateStudySetSuccessModal = false;

      return this.$router.push({
        name: "read-aloud",
        params: {
          organizationId: this.currentOrganizationId,
        },
      });
    },
    handleCreateNewStudySet() {
      this.handleReset();

      this.createStudySetSteps.active = 1;
      this.editMode = true;
      this.modals.showCreateStudySetSuccessModal = false;
    },
    handleConfirmCancel() {
      this.handleReset();

      return this.$router.push({
        name: "read-aloud",
        params: {
          organizationId: this.currentOrganizationId,
        },
      });
    },
    handleCancel() {
      this.modals.showLeaveCreateStudySetModal = true;
    },
    handleReset() {
      this.$store.dispatch("readAlouds/resetBuildingStudySet");
      this.$store.dispatch("readAlouds/resetNewReadAloud");
      this.$store.dispatch("readAlouds/resetImageUpload");
      this.$store.dispatch("readAlouds/resetWarmUp");
    },
  },
  async mounted() {
    this.handleReset();
    try {
      await this.$store.dispatch("studysets/getStudySetCategories");
    } catch (error) {
      error;
    }
  },
  destroyed() {
    this.handleReset();
  },
};
</script>

<style lang="scss" scoped>
.new-read-aloud {
  width: 100%;
}

#read-aloud-set-page {
  margin: 24px;

  @media only screen and (max-width: 768px) {
    margin: 0 30px;
  }

  h1 {
    border: 0;
    font-size: 30px;
    line-height: 45px;
    font-weight: 700;
  }

  .read-aloud-create-steps {
    margin-top: 25px;
  }

  .read-aloud-create-main {
    background-color: white;
    padding: 40px 0px 10px 0px;
  }

  ::v-deep .base-create-header {
    padding-bottom: 34px;
  }

  ::v-deep .circle-step {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 23px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    justify-content: center;
    padding-top: 8px;
    margin-right: 16px;
  }
}

.success-info {
  .success {
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #46c779;
    line-height: 30px;
  }

  p {
    margin-top: 20px;
    font-weight: 300;
    font-size: 18px;
    color: #546873;
    margin: 0;
  }
}

::v-deep .create-study-set-com-disable {
  opacity: 0.5;
}

.line-separate {
  border: 1px solid#E6E6E6;
  margin-bottom: 32px;
}
</style>
